import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, V1 } from "@/lib/api";
import { MapPin, ChevronRight } from "lucide-react";

export default function NearbySchools({ schoolId, limit = 6 }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!schoolId) return;
    setLoading(true);
    api.get(`${V1}/schools/${schoolId}/nearby`, { params: { limit } })
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [schoolId, limit]);

  if (loading) return null;
  if (!items.length) return null;

  return (
    <section data-testid="nearby-schools-section">
      <h2 className="font-display text-2xl font-bold mb-4">Yakın ve Benzer Okullar</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {items.map((s) => (
          <Link
            key={s.id}
            to={`/okul/${s.slug}`}
            className="p-4 rounded-xl border border-border bg-card hover:border-primary/50 transition flex items-center gap-3"
            data-testid={`nearby-school-${s.id}`}
          >
            <div className="h-12 w-12 rounded-md bg-muted overflow-hidden shrink-0">
              {s.logo_url && <img src={s.logo_url} alt={s.name} className="h-full w-full object-cover" />}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-medium text-sm truncate">{s.name}</div>
              <div className="text-xs text-muted-foreground flex items-center gap-1 mt-0.5">
                <MapPin className="h-3 w-3" /> {s.district || s.province}
                {s.distance_km != null && <span className="ml-2">· {s.distance_km} km</span>}
              </div>
            </div>
            <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0" />
          </Link>
        ))}
      </div>
    </section>
  );
}
